import { MANAGE_CUSTOMER, MANAGE_ITEM_API, WISHLIST_API } from "../../../../Utilities/APIs/APIs";
import SSCRUD from "../../../Partials/Layouts/CRUDs/CRUDLayouts/SSCRUD/SSCRUD";

function Wishlist() {
  return (
    <SSCRUD
        api={WISHLIST_API}
        screenTopicSingular={'Wishlist'}
        screenTopicPlural={'Wishlists'}
        
        // crud header props
        showTotalInHeading
        
        // select props
        selectApi={MANAGE_CUSTOMER + 'getAllCustomers'}
        selectType={'parent-child'}
        selectDBField={'customer'}
        selectName={'Customer'}

        // secondSelect props
        secondSelectApi={MANAGE_ITEM_API}
        secondSelectName={'Item'}
        secondSelectDBField={'item'}
    />
  )
}

export default Wishlist